import ErrorPage from '@components/Pages/Error/ErrorPage'
import PropTypes from 'prop-types'
import React from 'react'
import MobileDetect from 'mobile-detect'

const UnknownPage = (props) => <ErrorPage isErrorPage={props.isErrorPage} />

UnknownPage.propTypes = {
    isErrorPage: PropTypes.bool.isRequired
}

export const getServerSideProps = async (ctx) => {
    const md = new MobileDetect(ctx.req.headers['user-agent'])
    const isMobile = !!md.mobile()
    return {
        props: {
            isErrorPage: true,
            mobile: isMobile
        }
    }
}

export default UnknownPage
